import { render, staticRenderFns } from "./NotificationDrawerAggregate.vue?vue&type=template&id=20ab2995&scoped=true"
import script from "./NotificationDrawerAggregate.vue?vue&type=script&lang=ts"
export * from "./NotificationDrawerAggregate.vue?vue&type=script&lang=ts"
import style0 from "./NotificationDrawerAggregate.vue?vue&type=style&index=0&id=20ab2995&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ab2995",
  null
  
)

export default component.exports